import moment from "moment"

export function cleanJobDaysData(days) {

    return days.map(jobDay => {
        let jobDayListItem = { assignments: [...jobDay.crewMemberAssignments]}

        // date
        jobDayListItem['date'] = moment(jobDay.date).format("MM/DD/YYYY")
        jobDayListItem['id'] = jobDay.id

        // crew
        // -- get the foreman
        let foundForeman = false
        jobDay.crewMemberAssignments.forEach(assignment => {
            if(assignment.crewMember.isForeman) {
                jobDayListItem['foreman'] = `${assignment.crewMember.firstName
                } ${assignment.crewMember.lastName}`
                foundForeman = true
            }
        })
        if(!foundForeman) { 
            jobDayListItem['foreman'] = 'No Foreman Assigned'
        }
        // count the crew members
        jobDayListItem['crewSize'] = `${jobDay.crewMemberAssignments.length} Crew Member${jobDay.crewMemberAssignments.length > 1 || jobDay.crewMemberAssignments.length == 0 ? 's' : ''}`

        // time ticket status
        let preliminaryApprovalCount = 0
        let finalApprovalCount = 0
        let isPaidCount = 0
        let paidDate = null
        let ticketStatus = "No Crew Members Assigned"
        let notFinished = true

        jobDay.crewMemberAssignments.forEach(assignment => {
            if(!assignment.signOff) {
                return false
            }
            else if(!assignment.preliminaryApproval) { 
                preliminaryApprovalCount++
            } else if(!assignment.finalApproval) {
                finalApprovalCount++
            } else if(assignment.isPaid) {
                isPaidCount++
                paidDate = moment(assignment.paidDate)
            }
            notFinished = false
        })

        if(notFinished) {  jobDayListItem['ticketStatus'] = 'Ticket Not Finished'}
        else if(jobDay.crewMemberAssignments.length == 0) { jobDayListItem['ticketStatus'] = 'No Crew Members Assigned'}
        else if(preliminaryApprovalCount > 0){ jobDayListItem['ticketStatus'] = 'Needs Preliminary Approval'}
        else if(finalApprovalCount > 0){ jobDayListItem['ticketStatus'] = 'Needs Final Approval'}
        else if(isPaidCount == 0 ) { jobDayListItem['ticketStatus'] = 'Needs Payment'}
        else { jobDayListItem['ticketStatus'] = `Paid on ${paidDate.format("MM/DD/YYYY")}`}

        return jobDayListItem
    })
}

export function calculateManHours(jobDays) {

    let totalHours = 0

    jobDays.forEach(day => {

        day.assignments.forEach(assignment => {
            if(assignment.endTime) {
                const start = moment(`2000-01-01 ${assignment.startTime}`)
                const end = moment(`2000-01-01 ${assignment.endTime}`)
                const hours = end.diff(start, 'hours', true) - 0.5

                totalHours += hours
            }
        })
    })


    return totalHours
}

export function filterDays(days, startMoment, endMoment) {

    let filteredDays = []

    if(startMoment || endMoment) {

        days.forEach(day => {

            if(startMoment && !endMoment && moment(day.date).isSameOrAfter(startMoment)){
                filteredDays.push({...day})
            }
            else if(endMoment && !startMoment && moment(day.date).isSameOrBefore(endMoment)) {
                filteredDays.push({...day})
            }
            else if(startMoment && endMoment && moment(day.date).isBetween(startMoment.clone().subtract(1, 'day'), endMoment.clone().add(1, 'day'))) {
                filteredDays.push({...day})
            }
        })
    } else {
        filteredDays = [...days]
    }

    return filteredDays
}